import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Image } from 'foundations-components/transitional/components/Image';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import InstallCount from '../../common/components/InstallCount';
import { getAppCategoryI18nKey } from '../../common/utils/i18n';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_ICON_WIDTH = 48;
export default function AppSearchBarResult({
  categoryV2,
  companyName,
  firstPublishedAt,
  iconUrl,
  installsCount,
  name
}) {
  return /*#__PURE__*/_jsx(MediaObject, {
    itemLeft: /*#__PURE__*/_jsx("div", {
      style: {
        width: MAX_ICON_WIDTH
      },
      children: /*#__PURE__*/_jsx(Image, {
        src: iconUrl,
        role: "presentation"
      })
    }),
    children: /*#__PURE__*/_jsxs(View, {
      "data-selenium-id": `${name}-typeahead-search-result`,
      marginBlockEnd: "100",
      as: "div",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-200",
        display: "block",
        children: /*#__PURE__*/_jsx("b", {
          children: name
        })
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(Flex, {
          gap: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-apps-core.appSearchBarResult.companyName",
            options: {
              companyName
            }
          }), /*#__PURE__*/_jsx(InstallCount, {
            firstPublishedAt: firstPublishedAt,
            installsCount: installsCount
          }), /*#__PURE__*/_jsx(FormattedList, {
            children: categoryV2.map((value, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
              message: getAppCategoryI18nKey(value)
            }, `${index}-${value}`))
          })]
        })
      })]
    })
  });
}